var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32165_50123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33331 8H14.6666M1.33331 8C1.33331 11.6819 4.31808 14.6667 7.99998 14.6667M1.33331 8C1.33331 4.3181 4.31808 1.33333 7.99998 1.33333M14.6666 8C14.6666 11.6819 11.6819 14.6667 7.99998 14.6667M14.6666 8C14.6666 4.3181 11.6819 1.33333 7.99998 1.33333M7.99998 1.33333C9.6675 3.1589 10.6151 5.52802 10.6666 8C10.6151 10.472 9.6675 12.8411 7.99998 14.6667M7.99998 1.33333C6.33246 3.1589 5.38481 5.52802 5.33331 8C5.38481 10.472 6.33246 12.8411 7.99998 14.6667",
    stroke: "#475467",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32165_50123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe01);
export default __webpack_public_path__ + "static/media/globe-01.3136464bf5e63c84fa6d4b50acec8110.svg";
export { ForwardRef as ReactComponent };